import React, {useEffect, useState} from 'react';
import {PcPayRemainPopup} from './pc/PcPayRemainPopup'; // 注意这里是默认导入
import {MobilePayRemainPopup} from './mobile/MobilePayRemainPopup'; // 注意这里是默认导入

function PayRemainPopup({
                            isMobile,
                            openPayPopup,
                            closePopup,
                            display,
                            userName,
                            logEvent,
                            curSku,
                            curPriceIndex}) { // 接收 isMobile props
    const closePayPopup = () => {
        logEvent("closepayremainpopup_click", {
            sku: JSON.stringify(curSku?.prices?.[curPriceIndex]?.sku) || "",
            percent: curSku?.discount, // discount percentage
            string2: curSku?.prices?.[curPriceIndex]?.getUniqueId() || "" // SKU ID
        }, "", true); // instantly = true
        // 标记挽留页已关闭，不再显示
        localStorage.setItem('pay_remain_closed', 'true');
        closePopup();
    };
    const openPayRemainPopup = () => {
        logEvent("openpayremainpopup_click", {
            sku: JSON.stringify(curSku?.prices?.[curPriceIndex]?.sku) || "",
            percent: curSku?.discount, // discount percentage
            string2: curSku?.prices?.[curPriceIndex]?.getUniqueId() || "" // SKU ID
        }, "", true); // instantly = true
        openPayPopup();
    };


    // 确保 clickNext 和 clickPrev props 被传递，如果未提供则使用空函数作为默认值
    const commonProps = {
        display,
        userName,
        closePayPopup,
        openPayRemainPopup
    };

    if (isMobile) { // 根据 isMobile props 条件渲染
        return <MobilePayRemainPopup {...commonProps} />;
    } else {
        return <PcPayRemainPopup {...commonProps} />;
    }
}

export default PayRemainPopup;